export interface PreparedFormDataRowValue<T> {
    shouldSave: boolean;
    value?: T;
}

export const isExplicitNumericZero = (value: unknown, type?: string) => {
    if (type !== 'double' && type !== 'integer') return false;
    if (value === 0) return true;
    if (typeof value !== 'string') return false;

    const normalizedValue = value.trim().replace(',', '.');
    return normalizedValue !== '' && Number(normalizedValue) === 0;
};

export const prepareCodeValue = <T>(value: T): PreparedFormDataRowValue<T> =>
    value ? { shouldSave: true, value } : { shouldSave: false };

export const prepareFormDataRowValue = <T>(
    rawValue: unknown,
    type: string | undefined,
    transformValue: (value: unknown) => T,
): PreparedFormDataRowValue<T> => {
    const explicitZero = isExplicitNumericZero(rawValue, type);
    if (!rawValue && !explicitZero) return { shouldSave: false };

    const value = transformValue(rawValue);
    if (value || (value === 0 && explicitZero)) {
        return { shouldSave: true, value };
    }

    return { shouldSave: false };
};

export const resolveSetValue = async <T>(value: T | null | undefined, getFallbackValue: () => Promise<T>) => {
    if (value || value === 0) return value;
    return await getFallbackValue();
};
